  /**
   * User Selectors
   *
   * Redux selectors for user-related data and utilities
   */

  /**
   * Select the current user from state
   * @param {Object} state - Redux state
   * @returns {Object|null} - User object or null
   */
  export const selectUser = (state) => state.user?.company || null;

  /**
   * Check if the current user is a PLG (Product-Led Growth) account
   * @param {Object} state - Redux state
   * @returns {boolean} - True if user is a PLG account
   */
  export const selectIsPLGAccount = (state) => {
    const user = selectUser(state);
    return user?.is_plg_account === true || user?.is_plg_account === 1;
  };



  /**
   * HOC helper for mapStateToProps to reduce boilerplate
   * Use this in connect() to automatically get user from Redux
   *
   * @example
   * const mapStateToProps = mapUserToProps;
   * export default connect(mapStateToProps, { actions })(MyComponent);
   *
   * // Now your component receives: this.props.user
   */
  export const mapUserToProps = (state) => ({
    user: state.user?.company || null,
  });